import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import cx from 'classnames';
import { DropdownContext } from './dropdown';
export var DropdownTrigger = function (_a) {
    var children = _a.children, className = _a.className;
    var context = useContext(DropdownContext);
    if (!context) {
        throw new Error('DropdownTrigger must be used within a Dropdown');
    }
    var toggleDropdown = context.toggleDropdown;
    var handleClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        toggleDropdown();
    };
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    _jsx("div", { onClick: handleClick, className: cx(className), children: children }));
};
DropdownTrigger.defaultProps = {
    className: '',
};
